import type { Theme, SxProps } from '@mui/material';
import { Box } from '@mui/material';
import React, { useRef } from 'react';
import ReactPlayer from 'react-player/lazy';
import type { CSSProperties } from 'styled-components';
import type { ITheme } from '../../styles/theme';
import type { IPropsWithTestId } from '../../../constants/data-element-tracking-ids';
import {
  ELEMENT_ID_DATA_LOG_ATTRIBUTE,
  ELEMENT_ID_DATA_TEST_ATTRIBUTE,
} from '../../../constants/data-element-tracking-ids';

interface IProps extends Partial<IPropsWithTestId> {
  theme: ITheme;
  videoUrl: string;
  width: string | number | undefined;
  height: string | number | undefined;
  additionalStyles?: CSSProperties;
}

const VideoPreviewImage: React.FC<IProps> = ({
  theme,
  videoUrl,
  width,
  height,
  dataElementId,
  additionalStyles = {},
}) => {
  const playerRef = useRef<ReactPlayer>(null);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  const removedPlayIcon = <></>;

  const playerStyles: SxProps<Theme> = {
    pointerEvents: 'none',
    '& .react-player__preview': {
      backgroundColor: theme.colors.primary,
      ...additionalStyles,
    },
  };

  const handleClickPreview = () => {
    if (playerRef) {
      // This is the key to keeping the player in light mode
      playerRef.current?.showPreview();
    }
  };

  return (
    <Box sx={playerStyles}>
      <ReactPlayer
        ref={playerRef}
        url={videoUrl}
        light
        muted
        playIcon={removedPlayIcon}
        width={width}
        height={height}
        onClickPreview={handleClickPreview}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...{
          [ELEMENT_ID_DATA_LOG_ATTRIBUTE]: dataElementId,
          [ELEMENT_ID_DATA_TEST_ATTRIBUTE]: dataElementId,
        }}
      />
    </Box>
  );
};

export default VideoPreviewImage;
